import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'imageUrl',
})
export class ImageUrlPipe implements PipeTransform {
  constructor() {}
  transform(url: string): string {
    return `${environment.apiUrl}${url}`;
  }
}
